import { useEffect, useState } from "react";
import config from "../../../../../../config";
import Lightbox from "yet-another-react-lightbox";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/captions.css";
import "yet-another-react-lightbox/plugins/thumbnails.css";
import broken_image from "../../../../../../images/(2X)broken_image.png";
import QrCode from "../../../../../../Modal/QrCode";
import { useTranslation } from "../../../../../../context/TranslationContext";
const slides = [];
const CustomProductsList = ({ order, index, qcRequestData, status, orderDeliveryType, isGuest }) => {
  const { t } = useTranslation();
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [productImage, setProductImage] = useState("");
  const [customeProductImage, setCustomeProductImage] = useState("");
  const [customeProductImageLink, setCustomeProductImageLink] = useState("");
  const [productName] = useState("Custom Product " + (index + 1));
  const [modifiers, setModifiers] = useState([]);
  const [packagingType, setPackagingType] = useState("");
  const [itemSensitivity, setItemSensitivity] = useState("");
  const [isQrCodeModalOpen, setIsQrCodeModalOpen] = useState(false);
  const [initiatedText, setInitiatedText] = useState("");
  const showQrCodeModal = () => {
    setIsQrCodeModalOpen(true);
  };
  const handleQrCodeOk = () => {
    setIsQrCodeModalOpen(false);
  };
  const handleQrCodeCancel = () => {
    setIsQrCodeModalOpen(false);
  };

  useEffect(() => {
    // get image broken_image
    if (!isGuest) {
      if (order?.orderItemJson?.reference_link && order?.orderItemJson?.reference_link !== "") {
        setCustomeProductImageLink(order?.orderItemJson?.reference_link);
      }
      if (order?.orderItemJson?.customCakeImages && order?.orderItemJson?.customCakeImages.length > 0) {
        for (let key in order?.orderItemJson?.customCakeImages) {
          slides.push({
            src: config.AWS_URL + order?.orderItemJson?.customCakeImages[key]?.image,
          });
          if (parseInt(key) === 0) setProductImage(order?.orderItemJson?.customCakeImages[key]?.image);
        }
      } else {
        slides.push({
          src: broken_image,
        });
        setCustomeProductImage(broken_image);
      }

      // get modifier
      let modifiresData = [];
      for (let row of order.orderItemJson.modifierGroup) {
        let name_en = "";
        let values = [];
        for (let row1 of row.modifierGroupLocales) {
          if (row1.languageCode === "en") name_en = row1.name;
        }
        for (let row1 of row.modifierGroupItems) {
          for (let row2 of row1.modifierGroupItemLocales) {
            if (row2.languageCode === "en") values.push(row2.name);
          }
        }
        modifiresData.push({
          name_en: name_en,
          values: values.join(","),
        });
      }
      setModifiers(modifiresData);
      const lang = localStorage.getItem("lang") || "en";
      const packagingTypeName =
        order?.orderItemJson?.packageingType?.locales?.find((locale) => locale.languageCode === lang)?.name ||
        order?.orderItemJson?.packageingType?.locales?.find((locale) => locale.languageCode === "en")?.name ||
        "";
      setPackagingType(packagingTypeName);

      setItemSensitivity(order?.orderItemJson?.itemSensitivity?.data?.locales?.find((locale) => locale.languageCode === "en")?.name || "");
      let qcRequestDataText = "";

      for (let item of qcRequestData) {
        if (item.orderDetailId === order.id && item.status === "approve" && order.vendorType !== "host") qcRequestDataText = "Approved";
      }
      if (qcRequestDataText === "") {
        for (let item of qcRequestData) {
          if (item.orderDetailId === order.id && item.status === "reject" && order.vendorType !== "host") qcRequestDataText = "Reject";
        }
      }
      if (qcRequestDataText === "" || qcRequestDataText === "Reject") {
        for (let item of qcRequestData) {
          if (item.orderDetailId === order.id && item.status === "pending" && order.vendorType !== "host") qcRequestDataText = "Request Sent";
        }
      }
      if (qcRequestDataText === "") {
        for (let item of qcRequestData) {
          if (item.orderDetailId === order.id && item.status === "in_review" && order.vendorType !== "host") qcRequestDataText = "In Review";
        }
      }
      if (qcRequestDataText === "" && qcRequestData.length > 0 && order.vendorType !== "host") {
        qcRequestDataText = "Not Initiated";
      }
      setInitiatedText(qcRequestDataText);
    }
  }, [order, qcRequestData]);

  return (
    <>
      <div className="flex items-center my-3">
        <div className="basis-[50%] flex">
          <div className="flex flex-col justify-center items-center">
            {productImage && productImage !== "" ? (
              <img
                src={config.AWS_URL + productImage}
                alt=""
                className="w-full min-w-[50px] h-[50px] rounded"
                onClick={() => setLightboxOpen(true)}
              />
            ) : customeProductImage !== "" ? (
              <img
                src={customeProductImage}
                alt=""
                className="w-full min-w-[50px] h-[50px] rounded"
                onClick={() => setLightboxOpen(true)}
              />
            ) : null}
            <div className="text-[#808080] underline whitespace-nowrap cursor-pointer" onClick={() => setLightboxOpen(true)}>
              {t("images")}
            </div>
          </div>
          <div className="pl-2">
            <h3 className="text-sm font-semibold">{productName}</h3>
            <ul>
              {modifiers?.map((row, rowIndex) => {
                return (
                  <li key={rowIndex} className="text-gray-200 text-xs">
                    {row.name_en} : {row.values}
                  </li>
                );
              })}
              <li className="text-gray-200 text-xs">{t("packagingType")} : {packagingType}</li>
              <li className="text-gray-200 text-xs">{t("itemSensitivity")} : {itemSensitivity}</li>
              {customeProductImageLink !== "" ? (
                <li className="text-[#69b1ff] text-xs">
                  <a target="_blank" href={customeProductImageLink}>
                    {t("customProductImageLink")}
                  </a>
                </li>
              ) : null}
            </ul>
          </div>
        </div>
        <Lightbox open={lightboxOpen} close={() => setLightboxOpen(false)} slides={slides} plugins={[Thumbnails]} />
        <div className="basis-[16.66%] ">
          {status !== "placed" && status !== "confirmed" && order.qrImageLink ? (
            <img src={config.AWS_URL + order.qrImageLink} alt="QR-code" className="w-[33px] h-[33px] rounded" onClick={showQrCodeModal} />
          ) : null}
        </div>
        <div className="basis-[16.66%] flex justify-center">
          {initiatedText === "Approved" ? (
            <span className=" px-[10px] py-[3px] rounded text-sm bg-[#EDFFDF] text-[#2E8900]">{initiatedText}</span>
          ) : null}
          {initiatedText === "Reject" ? (
            <span className=" px-[10px] py-[3px] rounded text-sm bg-red-200 text-red-100">{initiatedText}</span>
          ) : null}
          {initiatedText === "Request Sent" ? (
            <span className=" px-[10px] py-[3px] rounded text-sm bg-[#F4F6FA] text-[#36618E]">{initiatedText}</span>
          ) : null}
          {initiatedText === "Not Initiated" ? (
            <span className=" px-[10px] py-[3px] rounded text-sm bg-[#FFEFD3] text-[#F9BE00]">{initiatedText}</span>
          ) : null}
          {initiatedText === "In Review" ? (
            <span className=" px-[10px] py-[3px] rounded text-sm bg-[#F4F6FA] text-[#36618E]">{initiatedText}</span>
          ) : null}
        </div>

        {order.totalAmount > 0 ? (
          <div className="basis-[16.66%] flex justify-end">
            <div className="text-sm font-medium">SAR {order.totalAmount}</div>
          </div>
        ) : null}
      </div>
      <QrCode
        isOpen={isQrCodeModalOpen}
        onOk={handleQrCodeOk}
        onCancel={handleQrCodeCancel}
        imageSrc={config.AWS_URL + order?.qrImageLink}
        barCode={order.barCode || ""}
      />
    </>
  );
};
export default CustomProductsList;
